import React from 'react';
import Markdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ErrorBoundaryTW } from '../errorBoundary/ErrorBoundaryTW';
import { MarkdownLink } from './markdownComponents/MarkdownLink';
import { MarkdownOrderedList } from './markdownComponents/lists/MarkdownOrderedList';
import { MarkdownUnorderedList } from './markdownComponents/lists/MarkdownUnorderedList';
import { MarkdownListItem } from './markdownComponents/lists/MarkdownListItem';
import GrayLine from '../../components/shared/GrayLine';

const DefaultComponents: Components = {
  a: MarkdownLink,
  hr: () => <GrayLine />,
  em: React.Fragment,
  i: React.Fragment,
  strong: React.Fragment,
  b: React.Fragment,
  code: React.Fragment,
  ol: MarkdownOrderedList,
  ul: MarkdownUnorderedList,
  li: MarkdownListItem,
  h1: React.Fragment,
  h2: React.Fragment,
  h3: React.Fragment,
  h4: React.Fragment,
  h5: React.Fragment,
  h6: React.Fragment,
  br: React.Fragment,
  blockquote: React.Fragment,
  img: React.Fragment,
  table: React.Fragment,
  tr: React.Fragment,
  th: React.Fragment,
  td: React.Fragment,
  tbody: React.Fragment,
  thead: React.Fragment,
  tfoot: React.Fragment,
  del: React.Fragment,
  iframe: React.Fragment,
};

export const GfmRenderer: React.FC<{ markdownText?: string; components?: Components }> = ({
  markdownText = '',
  components = DefaultComponents,
}) => {
  return (
    <ErrorBoundaryTW>
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {markdownText}
      </Markdown>
    </ErrorBoundaryTW>
  );
};
